import ArticleAssignmentCount from './ArticleAssignmentCount';
export default ArticleAssignmentCount;
